import { render, staticRenderFns } from "./SliderTestimonial.vue?vue&type=template&id=72294610&scoped=true&"
import script from "./SliderTestimonial.vue?vue&type=script&lang=js&"
export * from "./SliderTestimonial.vue?vue&type=script&lang=js&"
import style0 from "./SliderTestimonial.vue?vue&type=style&index=0&id=72294610&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72294610",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/components/Button.vue').default,Button: require('/app/components/Button.vue').default})
